<template>
  <div class="reader_allpage">
    <div class="contrainer">
      <div class="search">
        <el-input placeholder="跳转到页码" type='number' size="small" v-model="pageNum"
          @keyup.enter.native="changePage(pageNum-1)" clearable>
          <el-button slot="append" icon="el-icon-search" @click="changePage(pageNum-1)"></el-button>
        </el-input>
      </div>
      <div class="result_wrap">
        <div class="result">
          <div class="title" v-if="title">
            <img src="@/assets/img/colunm.png" />
            <span>{{title }}</span>
          </div>
          <div class="content">
            <p v-for="(item, index) in data" :id="`page${index}`" :key="index" @click="changePage(index)"
              :class="index === activeIndex ?'active':''">P{{ index+1 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      title: '',
      pageNum: '',
      activeIndex: this.currentIndex
    }
  },
  watch: {
    currentIndex: {
      handler (val) {
        this.activeIndex = val
        const pageDom = document.getElementById(`page${this.activeIndex}`)
        pageDom && pageDom.scrollIntoView && pageDom.scrollIntoView({ behavior: 'smooth' })
      }
    },
    data: {
      handler (val) {
        setTimeout(() => {
          const pageDom = document.getElementById(`page${this.activeIndex}`)
          pageDom && pageDom.scrollIntoView && pageDom.scrollIntoView({ behavior: 'smooth' })
        }, 0)
      }
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.bookName) {
      this.title = this.$route.query.bookName
    }
  },
  methods: {
    changePage (val) {
      if (val > this.data.length) {
        this.$message({
          message: '页码超出范围',
          type: 'warning'
        })
        return false
      }
      this.activeIndex = val
      this.$emit('changePage', val)
    }
  }
}
</script>
<style>
.reader_allpage{
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

  /* Firefox 隐藏加减按钮 */
  input[type="number"] {
    -moz-appearance: textfield !important;
  }
}

</style>
<style lang="less" scoped>
.reader_allpage {
  height: 100%;
  overflow: auto;

  .contrainer {
    .search {
      padding: 18px 20px 14px 20px;
      /deep/ .el-input-group__append {
        background: none;
        border-left: 0;
        padding: 0 10px;
      }
    }

    .result_wrap {
      .title {
        display: flex;
        align-items: center;
        width: 100%;
        height: 28px;
        line-height: 28px;
        // background: #F5F5F5;
        color: rgba(51, 51, 51, 1);
        padding: 0 20px;

        font-weight: 700;
        font-size: 14px;
      }
      img {
        display: inline-block;
        width: 16px;
        height: 16px;
      }
      span{
        flex:1;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .content {
        p {
          padding: 0px 20px 0px 44px;
          font-size: 14px;
          line-height: 32px;
          cursor: pointer;
          color: #2B2B2B;
          margin: 0;
          &.active{
            background: #EDE4D3;
            border-radius: 8px;
            color: #573E0D;
            font-weight: 400;
            // color: #2C7E8D  !important;
            // font-weight: 700;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/read/components/allPage.vue